<template>
  <oxd-sheet :gutters="false" class="gsl-hrm-dashboard-card">
    <oxd-loading-spinner v-if="loading" class="gsl-hrm-dashboard-card-loader" />
    <div v-else class="gsl-hrm-dashboard-card-content">
      <oxd-icon-button
        class="gsl-hrm-dashboard-card-icon"
        :name="icon"
        icon-type="svg"
        :display-type="displayType"
      />
      <div>
        <oxd-text tag="p" class="gsl-hrm-dashboard-card-name">
          {{ title }}
        </oxd-text>
        <div class="gsl-hrm-dashboard-card-sub-title">
          <oxd-text tag="p">
            {{ subTitle }}
          </oxd-text>
        </div>
      </div>
    </div>
  </oxd-sheet>
</template>
<script>
import {OxdSheet, OxdSpinner} from '@ohrm/oxd';

export default {
  name: 'DashboardCard',
  components: {
    'oxd-sheet': OxdSheet,
    'oxd-loading-spinner': OxdSpinner,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    displayType: {
      type: String,
      required: false,
      default: 'success',
    },
    loading: {
      type: Boolean,
      default: false,
    },

    subTitle: {
      type: [String, Number],
      default: null,
    },
    iconType: {
      type: String,
      default: undefined,
    },
  },
};
</script>
<style src="./dashboard-card.scss" lang="scss" scoped></style>
